import axios from "../http";
let module = "/sys";
function login(data){
  return axios.post(module +'/login',data);
}

function logout(){
  return axios.post(module +'/logout');
}

function getUserInfo(){
  return axios.post(module +'/user');
}

export default {
  login,
  logout,
  getUserInfo,
}
